import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Layouts from "./pages/Layouts";
import Login from "./pages/Login";
import Users from "./pages/Users";
import UserDetail from "./pages/UserDetail";
import AssessmentList from "./pages/AssessmentList";
import AssessmentDetail from "@pages/AssessmentDetail";
import AssessmentReport from "@pages/AssessmentReport";
import InqueryList from "./pages/InqueryList";
import Error from "./pages/Error";

function App() {
  return (
    <Routes>
      <Route element={<Layouts />}>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/users" element={<Users />} />
        <Route path="/user-detail/:id" element={<UserDetail />} />
        <Route path="/assessment" element={<AssessmentList />} />
        <Route path="/assessment/:id" element={<AssessmentDetail />} />
        <Route
          path="/assessment-report/:id/:grade_type"
          element={<AssessmentReport />}
        />
        <Route path="/inquery-list" element={<InqueryList />} />
        <Route path="/*" element={<Error />} />
      </Route>
    </Routes>
  );
}

export default App;
